import React from "react";
import { cx } from "../lib/ui";

/**
 * Seamless ticker. The track renders twice and translates by exactly
 * -50%, so the loop point is invisible whatever the content width.
 */
export default function Marquee({
  items,
  speed = 34,
  separator = "✦",
  className = "",
}) {
  const run = [...items, ...items];

  return (
    <div className={cx("group w-full select-none overflow-hidden", className)} aria-hidden="true">
      <div
        className="flex w-max animate-marquee group-hover:[animation-play-state:paused]"
        style={{ "--speed": `${speed}s` }}
      >
        {run.map((item, i) => (
          <span className="inline-flex items-center whitespace-nowrap" key={`${item}-${i}`}>
            {item}
            <i className="mx-[clamp(18px,3vw,44px)] text-[0.7em] not-italic opacity-40">
              {separator}
            </i>
          </span>
        ))}
      </div>
    </div>
  );
}
